const removeTrailingSlash = url => url.replace(new RegExp('/$'), '');

export default removeTrailingSlash;
